module.exports = __webpack_public_path__ + "static/img/ai_bg.8a09e33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/matrix/ai_bg.png
// module id = THfm
// module chunks = 34